import { Box, Typography } from '@mui/material';
import { cardSx, FONT, PAGE_BG, sectionSubtitleSx } from '../reportTokens';

/**
 * What the reader sees when the page itself throws.
 *
 * Without a boundary React unmounts everything and leaves a blank white page,
 * which reads as "the link is broken" when the report is fine and the fault is
 * ours. The error has already gone to Sentry by the time this renders.
 */
function ReportCrashed() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: PAGE_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Box role='alert' sx={{ ...cardSx, maxWidth: 440, textAlign: 'center' }}>
        <Typography sx={{ fontSize: FONT.cardTitle, fontWeight: 700 }}>
          This report could not be displayed
        </Typography>
        <Typography sx={{ ...sectionSubtitleSx, mt: 1 }}>
          Something went wrong on our side. Try reloading the page; if it keeps
          happening, let whoever sent you the link know.
        </Typography>
      </Box>
    </Box>
  );
}

export default ReportCrashed;
